export const DEFAULT_IMG = ['https://assets.sursung.com/pkg/static/ops/19052010009498_2.jpg'] // 默认图

export const PUSH_TAB_COMBAL_WX_AND_PROMOTION = 'combalWxAndPromotion' // 推广商品海报 组合了转发到微信的
export const PUSH_TAB_WX_FORWARD_KEY = 'forward' // 转发到微信
export const PUSH_TAB_PROMOTION_KEY = 'promotion' // 创建海报
export const PUSH_TAB_WX_MASS_KEY = 'wxmass' // 微信群发
export const PUSH_TAB_WX_CIRCLE_KEY = 'wxcircle' // 微信朋友圈

export const WORK_WEI_XIN_SHARE = 'workWeiXin' // 分享详情

export const MAX_WX_POSTE_MAX_SIZE = 1900000 // 海报最大图片尺寸 判断生成的图片小于2m  macOS 按1000 Windows 按 1024

export const PARNER_MANAGE_SHOP_URL = '/partnerManageV2/myPartnerShop'
